import React, { useState, useEffect, useCallback } from 'react';
import { Box, Tabs, Tab, Typography, Paper, Alert } from '@mui/material';
import axios from 'axios';
import { APIURL } from '../../config';
import ReferralGrid from './ReferralGrid';
import CreateReferral from './CreateReferral';
import ReferralPartners from './ReferralPartners';
import OutboundReferralsControlRoom from './OutboundReferralsControlRoom';
// Removed form rendering and print dependencies as create-new referral is disabled


const TABS = {  // Main top-level tabs
  CONTROL_ROOM: 0,
  INBOUND: 1,
  CAL: 2,
  CREATE: 3,
  PARTNERS: 4,
};

// Removed unused initialFormState

const Referral = (props) => {
  const { comp_id, user } = props;
  const [tab, setTab] = useState(TABS.CONTROL_ROOM); // default to new Control Room
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // Create-new referral is disabled; only grid and empty tab are active

  console.log(props);

  const fetchAll = useCallback(async () => {
    // Keep basic health check to set error state if API is unreachable (grid will also fetch independently)
    setLoading(true);
    setError(null);
    try {
      await axios.get(`${APIURL}/referral`, { params: { comp_id, status: 'PENDING' } });
    } catch (e) {
      console.error('Referral fetch error', e);
      setError('Unable to load referrals at this time.');
    } finally {
      setLoading(false);
    }
  }, [comp_id]);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  // Form loading removed

  const handleTabChange = (_e, v) => {
    // No preloading or side effects; create tab is now empty
    setTab(v);
  };
  // Render the boilerplate CreateReferral component
  const renderCreate = () => (<CreateReferral comp_id={comp_id} user={user} com_name={user?.company_name} />);
  // Sidebar removed as per request

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      
      <Tabs value={tab} onChange={handleTabChange} sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tab label="Sent Referrals" value={TABS.CONTROL_ROOM} />
        <Tab label="Received Referrals" value={TABS.INBOUND} />
        {props.user?.permissions?.CreateNewReferral && <Tab label="Create New Referral" value={TABS.CREATE} />}
        <Tab label="Partner Network" value={TABS.PARTNERS} />
      </Tabs>
      <Box sx={{ flex: 1, overflow: 'auto', display: 'flex', minWidth: 0 }}>
        <Box sx={{ flex: 1, mt: 1, minWidth: 0 }}>
          {tab === TABS.CONTROL_ROOM && (error ? <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert> : <OutboundReferralsControlRoom comp_id={comp_id} user={user} com_name={user?.company_name} mode="outbound" />)}
          {tab === TABS.INBOUND && (error ? <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert> : <OutboundReferralsControlRoom comp_id={comp_id} user={user} com_name={user?.company_name} mode="inbound" />)}
          {tab === TABS.CREATE && renderCreate()}
          {tab === TABS.PARTNERS && <ReferralPartners />}
        </Box>
      </Box>
    </Box>
  );
};

export default Referral;
